module.exports = __webpack_public_path__ + "static/media/red_check.05add52a.svg";